import * as React from 'react'

import DialogTitle from '@mui/material/DialogTitle'
import {default as MuiDialog} from '@mui/material/Dialog'
import {IconButton} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

export interface SimpleDialogProps {
  open: boolean
  onClose: () => void
  children: React.ReactNode
  title: string
}

export const Dialog = (props: SimpleDialogProps) => {
  const {onClose, open, title, children} = props

  const handleClose = () => {
    onClose()
  }

  return (
    <MuiDialog onClose={handleClose} open={open}>
      <DialogTitle>{title}</DialogTitle>

      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>

      {children}
    </MuiDialog>
  )
}
